import { render } from "./ListCutiPendingView.vue?vue&type=template&id=60b43fce"
import script from "./ListCutiPendingView.vue?vue&type=script&lang=js"
export * from "./ListCutiPendingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__